import { render, staticRenderFns } from "./quotationPreview.vue?vue&type=template&id=61afe48c&scoped=true&"
import script from "./quotationPreview.vue?vue&type=script&lang=js&"
export * from "./quotationPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61afe48c",
  null
  
)

export default component.exports